import React from "react";
import { useSelector } from "react-redux";
import Timer from "../../../../components/ui/timer/Timer";
import classes from "./FinalDateCountdown.module.css";

const FinalDateCountdown = ({ targetDate, timeReached = 10, onTimeReached }) => {

  const { texts } = useSelector((state) => state.translate);
  const date = new Date(targetDate);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  if (!targetDate)
    return null

  return (
    <div className={classes.finalDateWrapper}>
      <Timer targetDate={targetDate} timeReached={timeReached} onTimeReached={onTimeReached} />
      <p className={classes.finalDateText}>
        {texts?.finalStartsOn}
        {`${day}.${month} `}
        {texts?.bBefore}
        {`${hours}:${minutes}`}
      </p>
    </div>
  );
};

export default FinalDateCountdown;
